import { connect } from 'react-redux'
import { doDeleteFile } from 'actions/attachments'
import DesktopAttachment from './Desktop'

const perform = {
  doDeleteFile,
}

export default connect(null, perform)(DesktopAttachment)
